export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7915.7f739587.jpg";